import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HistoryHelperService} from '../../services/history-helper.service';

@Component({
  selector: 'lib-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  constructor(private router: Router, private historyHelperService: HistoryHelperService) {
  }

  ngOnInit(): void {
  }

  goHome() {
    this.router.navigateByUrl( '/');
  }
}
